import React, { useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import s from './Modal.module.css';

/**
 * Reusable modal component.
 *
 * Closes ONLY when the user clicks the X button (calls `onClose`).
 * Outside-click on the overlay and the Escape key are intentionally NO-OPs
 * — match-detail and confirm dialogs must not close accidentally.
 *
 * Props: open, onClose, title, children, footer, wide, xl
 */
export default function Modal({ open, onClose, title, children, footer, wide, xl }) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = ''; };
    }
    document.body.style.overflow = '';
  }, [open]);

  if (!open) return null;

  return (
    <div className={s.overlay}>
      <div
        className={`${s.modal} ${xl ? s.modalXl : (wide ? s.modalWide : '')}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={s.header}>
          <h3 className={s.title}>{title}</h3>
          <button className={s.closeBtn} onClick={onClose}><FiX /></button>
        </div>
        <div className={s.body}>
          {children}
        </div>
        {footer && <div className={s.footer}>{footer}</div>}
      </div>
    </div>
  );
}

export { s as modalStyles };

